function doFaqTabs() {
  if (customElements.get("faq-tabs")) return null;

  class FaqTabs extends HTMLElement {
    constructor() {
      super();
      this.liTags = this.querySelectorAll(".li-tag");
      this.tabsAndtagsWrapper = this.querySelector(".tabs-and-content-wrapper");
      this.searchWrapper = this.querySelector(".search-keywords-faq");

      this.init();
    }

    init() {
      this.appendAllArticlesByTag(() => {
        this.handleAllAccordionOpen();

        this.liTags.forEach((liTag, index) => {
          if (index === 0) {
            this.openTag(liTag);
          }
          this.handleTag(liTag);
        });

        // onen first tag and first article
        const urlOpen = this.handleURLopen();
        if (urlOpen === null) {
          const firstTagFirstAccordion = this.liTags[0].querySelector(
            ".snippet-generalAccordion"
          );
          const firstTagFirstAccordionHeader =
            firstTagFirstAccordion.querySelector(".generalAccordion-header");

          this.openTag(this.liTags[0]);

          $(firstTagFirstAccordionHeader).trigger("click");
        }
      });

      this.searchWrapper
        .querySelector(".faqTabs-search-submit")
        .addEventListener("click", (e) => {
          e.preventDefault();
          this.handleSearch();
        });

      this.searchWrapper
        .querySelector(".clear-wrapper")
        .addEventListener("click", (e) => {
          e.preventDefault();
          this.handleClearSearch();
        });
    }

    autoScrollElementTop(element, offset = 150) {
      if (element != null) {
        const position = element.getBoundingClientRect();
        window.scroll({
          top: position.top + window.scrollY - offset,
          left: 0,
          behavior: "smooth",
        });
      }
    }

    handleURLopen() {
      const url = window.location.search;
      const params = new URLSearchParams(url);
      const urlQuery = params.get("q");

      if (urlQuery == null) return null;
      const targetedArticleHeader = this.querySelector(
        `.snippet-generalAccordion[data-article-handle="${urlQuery}"] .generalAccordion-header`
      );
      if (targetedArticleHeader == null) return null;

      const liTag = targetedArticleHeader.closest(".li-tag");
      const tagBody = liTag.querySelector(".tag-body");
      this.openTag(liTag);
      this.tabsAndtagsWrapper.style.minHeight = tagBody.offsetHeight + "px";
      $(targetedArticleHeader).trigger("click");
      setTimeout(
        () => this.autoScrollElementTop(targetedArticleHeader, 80),
        500
      );
    }

    handleClearSearch() {
      const faqResultsElement = this.querySelector(".faqTabs-results");
      const clearWrapper = this.querySelector(".clear-wrapper");
      const searchField = this.searchWrapper.querySelector(
        ".faqTabs-search-input"
      );

      faqResultsElement.innerHTML = "";
      clearWrapper.style.display = "none";
      searchField.value = "";
    }

    /**
     * In addition to the origin click event found at generalAccordion.js
     * This changes the height of its tag-body when its open.
     */
    handleAllAccordionOpen() {
      const allAccordions = this.querySelectorAll(".snippet-generalAccordion ");
      allAccordions.forEach((accordion) => {
        const accordionHeader = accordion.querySelector(
          ".generalAccordion-header"
        );

        accordionHeader &&
          accordionHeader.addEventListener("click", (e) => {
            const tagBody = e.target.closest(".tag-body");
            this.tabsAndtagsWrapper.style.minHeight =
              tagBody.offsetHeight + "px";

            if (parseFloat(accordion.dataset.status) === 1) {
              this.replaceUrlParam(accordion.dataset.articleHandle);
            }
          });
      });
    }

    /**
     *
     * @param {Element} tagBody
     * @param {Element} accordion
     * @param {String} action open | close
     * @returns
     */
    openAccordion(tagBody, accordion, action = "open") {
      if (parseFloat(accordion.dataset.status) === 0 && action === "open") {
        accordion.setAttribute("data-status", 1);
        this.replaceUrlParam(accordion.dataset.articleHandle);
        this.tabsAndtagsWrapper.style.minHeight = tagBody.offsetHeight + "px";
        return;
      }
      accordion.setAttribute("data-status", 0);
      this.tabsAndtagsWrapper.style.minHeight = tagBody.offsetHeight + "px";
      return;
    }

    /**
     * @param {Element} liTag
     */
    handleTag(liTag) {
      const tagTrigger = liTag.querySelector(".tag-trigger");
      const tagBody = liTag.querySelector(".tag-body");
      const firstAccordionForThisTag = liTag.querySelector(
        ".snippet-generalAccordion"
      );
      tagTrigger &&
        tagTrigger.addEventListener("click", () => {
          if (liTag.dataset.status === "1") {
            return this.disableAllTags();
          }
          this.openTag(liTag);
          this.openAccordion(tagBody, firstAccordionForThisTag);
        });
    }

    /**
     * @param {Element} liTag
     */
    openTag(liTag) {
      const tagBody = liTag.querySelector(".tag-body");
      this.disableAllTags();
      liTag.setAttribute("data-status", 1);
      this.tabsAndtagsWrapper.style.minHeight = tagBody.offsetHeight + "px";
    }

    replaceUrlParam(replaceWith) {
      const params = new URLSearchParams(window.location.href);
      params.set("q", replaceWith);
      const updatedUrl =
        window.location.origin + window.location.pathname + "?q=" + replaceWith;

      // Update the URL without navigating away
      history.replaceState(null, "", updatedUrl);
    }

    /**
     * Runs Fuse search to search through the articles for a keyword
     * and displays it to the user
     * @returns appends html to the dom
     */
    async handleSearch() {
      const searchField = this.searchWrapper.querySelector(
        ".faqTabs-search-input"
      );

      const faqResultsElement = this.querySelector(".faqTabs-results");
      const clearWrapper = this.querySelector(".clear-wrapper");
      const fuse = new Fuse(await this.getAllArticles(), {
        distance: 500,
        threshold: 0.2,
        keys: ["title", "bodyNoHtml"],
      });
      const result = fuse.search(searchField.value);
      const htmlWrapper = (resultBody) => `
        <div class="faqTabs-inner mb-xs">${resultBody}</div>
      `;

      if (result.length === 0) {
        clearWrapper.style.display = "block";

        this.searchWrapper.classList.add("search-keywords-faq-active");
        return (faqResultsElement.innerHTML = htmlWrapper(
          `<p>There are no results for your keyword/s</p>`
        ));
      }

      const articles = result
        .map((article) => {
          return `
            <article>
            <h3 class="h4">${article.item.title}</h3>
            <div class="rte">
      ${article.item.body_html}
            </div>
          </article>
            `;
        })
        .join("");

      clearWrapper.style.display = "block";
      this.searchWrapper.classList.add("search-keywords-faq-active");
      return (faqResultsElement.innerHTML = htmlWrapper(
        `<p class="has-results">Search results (${result.length})</p>${articles}`
      ));
    }

    disableAllTags() {
      this.liTags.forEach((liTag) => liTag.setAttribute("data-status", 0));
    }

    /**
     *
     * @returns Absolutely all articles by the blog handle
     */
    async getAllArticles() {
      const pagesNumber = parseFloat(this.dataset.pagesNumber);
      const pagesNumberArray = new Array(pagesNumber).fill(0);
      const awaitedArticles = pagesNumberArray.map(
        async (pageUndefined, index) => {
          const receivedArticles = await this.getArticlesByPageAndHandle(
            index + 1,
            this.dataset.blogHandle
          );
          return receivedArticles;
        }
      );
      const allArticlesArrays = await Promise.all(awaitedArticles);
      var allArticlesComplete = [].concat(...allArticlesArrays);
      var allArticles = [];

      if (allArticlesComplete == null) return null;

      // get country code if any
      // third entry is either country code or type of page e.g. "pages" "blog"
      var country_code = "";
      var url_split = window.location.href.split("/");
      if (url_split.length > 3 && url_split[3].split("-").length == 2) {
        // assume that country codes follow hyphenated format e.g. en-us
        country_code = url_split[3].split("-")[1];
      }

      allArticlesComplete.forEach((_article, idx) => {
        let added = false;
        let hidden = false;
        if (country_code.length > 0) {
          // if there is a prefix of "visible" followed by current code, add it to the final output article list
          if (_article.tags.includes("visible-")) {
            if (_article.tags.includes("visible-" + country_code)) {
              allArticles.push(_article);
              added = true;
            } else {
              hidden = true;
            }
          }
          // if it hasn't arleady been added and there isn't a prefix of, "hide" followed by current country code, add it to the final output article list
          else if (
            !added &&
            !hidden &&
            !_article.tags.includes("hide-" + country_code)
          ) {
            allArticles.push(_article);
          }
        } else {
          //if there is no country code - don't add it if it contains a "visible-" tag
          if (!_article.tags.includes("visible-")) {
            allArticles.push(_article);
          }
        }
      });

      const allArticlesWithAdditions = allArticles.map((article) => {
        const { title, body_html, tags, handle } = article;
        const bodyNoHtml = body_html.replace(/(<([^>]+)>)/gi, "");
        return {
          title,
          body_html,
          tags,
          bodyNoHtml,
          handle,
        };
      });

      if (allArticlesWithAdditions == null) return null;
      return allArticlesWithAdditions;
    }

    makeFetchUrl() {
      const url = new URL(window.location.href);
      const firstSegment = url.pathname.split("/")[1];

      // eg. ja-jp or zz-pp
      const regex = /^[a-z]{2}-[a-z]{2}$/;
      const isValidFormat = regex.test(firstSegment);

      return isValidFormat
        ? `/${firstSegment}/pages/blog-data-json`
        : `/pages/blog-data-json`;
    }

    /**
     * Gets 50 articles by the url query param of 'page'. Eg. /?page=x
     * byPage, means pagination page
     * @param {Number} pageNumber
     * @param {String} blogHandle
     * @returns Array of articles
     */
    async getArticlesByPageAndHandle(pageNumber, blogHandle) {
      const url = `${this.makeFetchUrl()}?page=${pageNumber}`;
      const articles = fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const articlesScript = html.querySelector(
            `[data-blog-handle="${blogHandle}"]`
          );
          console.log(articlesScript);
          const articlesJson = JSON.parse(articlesScript.textContent);

          if (articlesJson == null) return [];
          return articlesJson;
        })
        .catch((e) => console.error(e));
      if (articles == null) return [];

      return articles;
    }

    /**
     *
     * @param {Object} data {title: string, body: string, handle: string}
     */
    generalAccordionHtml(data) {
      const { title, body, handle } = data;

      const gaHtml = `
      <general-accordion class="snippet-generalAccordion " data-status="0" data-article-handle="${handle}">
        <article>
          <div class="generalAccordion-header" data-trigger="">
            <h5>${title}</h5>
            <span class="this-icons">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus " fill="none" viewBox="0 0 10 10">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus " fill="none" viewBox="0 0 10 2">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
              </svg>
            </span>
          </div>
          <div class="generalAccordion-body" data-content="" style="display: none;">
            <div class="rte">${body}</div>
          </div>
        </article>
      </general-accordion>
      `;

      return gaHtml;
    }

    /**
     * Attach each group of articles to their designated tag group
     * @param afterGetAll call back function executed after allArticles are on the DOM
     */
    appendAllArticlesByTag(afterGetAll) {
      (async () => {
        const getAllArticles = await this.getAllArticles();

        this.querySelectorAll(".blog-tags .li-tag").forEach(async (liTag) => {
          const articlesByThisTag = getAllArticles.filter((article) =>
            article.tags.includes(liTag.dataset.tag)
          );

          if (articlesByThisTag.length >= 1) {
            // Merge the html
            const articlesByThisTagMerged = articlesByThisTag
              .map((article) => {
                return this.generalAccordionHtml({
                  title: article.title,
                  body: article.body_html,
                  handle: article.handle,
                });
              })
              .join("");

            // Assign group of articles to its tag's body
            liTag.querySelector(".tag-body").innerHTML =
              articlesByThisTagMerged;
          } else {
            // if the tag group is empty - hide it (happens if articles are hidden in particlar country code)
            liTag.classList.add("hide-tag");
          }
        });
        afterGetAll();
      })();
    }
  }

  customElements.define("faq-tabs", FaqTabs);
}
doFaqTabs();
